import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/apps/web/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/assets/css/App.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/src/app/components/footer/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/components/navbar/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/components/PodcastPlayer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/components/pwa/DevServiceWorkerCleanup.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/components/social/social.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/components/support/FloatingBugReport.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PodcastProvider"] */ "/vercel/path0/apps/web/src/app/context/PodcastContext.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/funcs/darkLight.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/funcs/funcs.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer","Flip"] */ "/vercel/path0/node_modules/react-toastify/dist/index.mjs");
